import axios from "axios";
import config from "../configs/Configs.json";

const { API__SERVER } = config;

// Chat service centralizing chat-related API calls
export const chatService = {
  async getUnreadCount(userId) {
    try {
      // Preferred new backend endpoint per spec
      const { data } = await axios.get(`${API__SERVER}/chat/unread-count`, {
        params: { userId },
      });
      if (typeof data?.count === "number") return data.count;
    } catch (_) {}

    // Fallback: derive from existing history API structure
    try {
      const res = await axios.get(`${API__SERVER}/chat/${userId}`);
      const count = res?.data?.list_message_no_read?.all_message_user_receiver_no_read;
      if (typeof count === "number") return count;
      return 0;
    } catch (e) {
      return 0;
    }
  },

  async getRecentConversations(userId, page = 1, limit = 20) {
    try {
      const res = await axios.get(`${API__SERVER}/chat/${userId}`, { params: { page, limit } });
      return Array.isArray(res?.data?.data) ? res.data.data : [];
    } catch (e) {
      return [];
    }
  },
};

export default chatService;


